const studentgroups = {
	title: "Student Groups",
	new_studentgroup: "New Student Group",
	edit_studentgroup: "Edit Student Group: {name}",
	view_studentgroup: "View Student Group: {name}",
	list_title: "List of Student Groups",
	list_subtitle: "Manage Student Groups",
	create_title: "Create New Student Group",
	update_title: "Update Student Group",
	id: "ID",
	name: "Group Name",
	code: "Program Area Code",
	groupcode: "Group Code",
	status: "Status",
	created_by: "Created By",
	educationprogram_id: "Education Program",
	qty: "Qty",
	enrol_tooltip: "Enroll selected students to a course",
	new_tooltip: "Add new student",
	select_tooltip: "Add students from student list",
	remove_tooltip: "Remove student from group",
};
export default studentgroups;